import React, { Component } from "react";
import DonutPMDecisionsPromotionalSpend from "./charts/DonutPMDecisionsPromotionalSpend";
import ModalPMDecisionsPromotionalSpend from "../../../containers/modal/ModalPMDecisionsPromotionalSpend";
import PromoSpendTextMasking from "../../promo-spend/PromoSpendTextMasking";
import FontAwesome from "react-fontawesome";
import { deleteRequest } from "../../../api/ApiService";
import { hexToRgba, logError } from "../../../services/utils";
import { decrementUnacceptedDecisions } from "../../../api/SubmitDecisions";
import Styled from "components/pm/style";
import Teams from "api/Teams";
import AbbreviateNumber from "../../ui-building-blocks/numbers/AbbreviateNumber";
import { view } from "@risingstack/react-easy-state";

class PMDecisionsPromotionalSpend extends Component {
  constructor(props) {
    super(props);

    this.state = {
      products: props.products,
      promos: props.promos,
      products_prepared: {}
    };
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.state.products !== nextProps.products ||
      this.state.promos !== nextProps.promos
    ) {
      this.setState(
        {
          products: nextProps.products,
          promos: nextProps.promos
        },
        () => {
          this.prepareData();
        }
      );
    }
  }

  componentDidMount() {
    this.prepareData();
  }

  prepareData() {
    let products_prepared = {};

    this.state.products.forEach(item => {
      products_prepared[item.id] = {
        name: item.name,
        traditional_spend: 0,
        digital_spend: 0,
        traditional_spend_id: 0,
        digital_spend_id: 0,
        player_traditional: null,
        player_digital: null
      };
    });

    this.state.promos.forEach(item => {
      if (item.product in products_prepared) {
        if (
          item.client === this.props.marketing_clients["Traditional Marketing"]
        ) {
          products_prepared[item.product].traditional_spend = item.spend;
          products_prepared[item.product].traditional_spend_id = item.id;
          products_prepared[item.product].player_traditional = item.player;
        } else if (
          item.client === this.props.marketing_clients["Digital Marketing"]
        ) {
          products_prepared[item.product].digital_spend = item.spend;
          products_prepared[item.product].digital_spend_id = item.id;
          products_prepared[item.product].player_digital = item.player;
        }
      }
    });

    this.setState({
      products_prepared
    });
  }

  onRemovePromos = (e, product) => {
    e.preventDefault();

    let requests = [];

    if (
      product.traditional_spend_id > 0 &&
      product.player_traditional !== null
    ) {
      requests.push(this.removePromosRequest(product.traditional_spend_id));
    }

    if (product.digital_spend_id > 0 && product.player_digital !== null) {
      requests.push(this.removePromosRequest(product.digital_spend_id));
    }

    const joinRequest = Promise.all(requests);

    joinRequest
      .then(res => {
        this.props.showSuccessMessage(`Promo decision set for product ${product.name} was successfully deleted`);
        decrementUnacceptedDecisions("marketing");
        this.props.reloadData();
        this.props.getSubmissionData();
      })
      .catch(err => {
        logError(err, "PMDecisionsPromotionalSpend", "onRemovePromos");
      });
  };

  removePromosRequest(object_id) {
    return deleteRequest(
      `${process.env.REACT_APP_API_URL}team/promos/${object_id}/`
    );
  }

  get sumOfCashReceiptsPriorRoundSales() {
    const { accountsReceivable } = this.props;

    return accountsReceivable;
  }

  get total() {
    return - this.sumOfTraditionalMarketingSpend - this.sumOfDigitalMarketingSpend;
  }

  get sumOfTraditionalMarketingSpend() {
    return this.calculateSum(
      this.props.promos,
      this.props.marketing_clients["Traditional Marketing"],
      "spend"
    );
  }

  get sumOfDigitalMarketingSpend() {
    return this.calculateSum(
      this.props.promos,
      this.props.marketing_clients["Digital Marketing"],
      "spend"
    );
  }

  calculateSum(data, type, key) {
    let sum = 0;
    let l = data.length;

    for (let i = 0; i < l; i += 1) {
      if (data[i].player !== null && data[i].client === type) {
        sum += data[i][key];
      }
    }

    return sum;
  }

  render() {

    return (
      <Styled.WhiteBlockColumn>
        <div>
          <Styled.PS.Title>Promotional Spend</Styled.PS.Title>
          <ModalPMDecisionsPromotionalSpend
            reloadData={this.props.reloadData}
            products={this.state.products_prepared}
            marketing_clients={this.props.marketing_clients}
            price_forecasts={this.props.price_forecasts}
            hasAccess={this.props.hasAccess}
            showRoleAlert={this.props.showRoleAlert}
            countOfProducts={this.props.countOfProducts}
            tourMode={this.props.tourMode}
            getSubmissionData={this.props.getSubmissionData}
            currentRound={this.props.currentRound}
            roundInUrl={this.props.roundInUrl}
            rounds={this.props.rounds}
            showSuccessMessage={this.props.showSuccessMessage}
          />
        </div>

        <Styled.PS.Amount>
          <AbbreviateNumber value={this.total} />
        </Styled.PS.Amount>

        <DonutPMDecisionsPromotionalSpend
          products={this.state.products_prepared}
        />

        <Styled.PS.Table rowColor={hexToRgba(Teams.currentTeamColorLevel1(), 0.3)}>
          <table>
            <thead>
              <tr>
                <th>Product</th>
                <th>Traditional</th>
                <th>Digital</th>
                <th>Total</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {Object.keys(this.state.products_prepared).map(product_id => {
                let product = this.state.products_prepared[product_id];
                let total = product.traditional_spend + product.digital_spend;
                let can_remove = false;
                if (
                  product.player_traditional !== null ||
                  product.player_digital !== null
                ) {
                  can_remove = true;
                }
                if (this.props.actionsAllowed === false) {
                  can_remove = false;
                }

                return (
                  <tr key={product_id}>
                    <td>{product.name}</td>
                    <td>
                      <PromoSpendTextMasking
                        value={product.traditional_spend}
                      />
                    </td>
                    <td>
                      <PromoSpendTextMasking value={product.digital_spend} />
                    </td>
                    <td>
                      <PromoSpendTextMasking value={total} />
                    </td>
                    <td>
                      {can_remove === true && (
                        <a
                          href="/#"
                          className="remove-operation"
                          onClick={e => this.onRemovePromos(e, product)}
                        >
                          <FontAwesome name="trash-o" />
                        </a>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </Styled.PS.Table>
      </Styled.WhiteBlockColumn>
    );
  }
}

export default view(PMDecisionsPromotionalSpend);



// WEBPACK FOOTER //
// ./src/components/pm/decisions/PMDecisionsPromotionalSpend.js